module.exports = __webpack_public_path__ + "static/media/computers2.864971ea.png";